// The purpose of this file is to keep an internal categorization of champions
// This is primarily useful for the purposes of "coaching"/performance anaylsis
// This data is not available from Riot nor is it "official"
// Reference list (we don't stictly adhere to this) https://leagueoflegends.fandom.com/wiki/Champion_classes
// 🚨 THIS NEEDS TO BE UPDATED WITH NEW CHAMPION RELEASES FOR COACHING TO BE ACCURATE 🚨
// Please ensure this is updated by someone with strong League knowledge
// when new champions are released (few times a year)
// This list is also useful because we now dont have to rely on static data for key -> id mapping

export const PRIMARY_CLASSES = {
  CONTROLLER: "CONTROLLER",
  FIGHTER: "FIGHTER",
  MAGE: "MAGE",
  MARKSMAN: "MARKSMAN",
  SLAYER: "SLAYER",
  TANK: "TANK",
  SPECIALIST: "SPECIALIST",
};
export const SECONDARY_CLASSES = {
  ENCHANTER: "ENCHANTER",
  CATCHER: "CATCHER",
  JUGGERNAUT: "JUGGERNAUT",
  DIVER: "DIVER",
  BURST: "BURST",
  BATTLEMAGE: "BATTLEMAGE",
  ARTILLERY: "ARTILLERY",
  ASSASSIN: "ASSASSIN",
  SKIRMISHER: "SKIRMISHER",
  VANGUARD: "VANGUARD",
  WARDEN: "WARDEN",
  MARKSMAN: "MARKSMAN",
};
export const CHAMPION_CLASS_LABELS = {
  [PRIMARY_CLASSES.CONTROLLER]: [
    "lol:championClasses.controller",
    "Controller",
  ],
  [PRIMARY_CLASSES.FIGHTER]: ["lol:championClasses.fighter", "Fighter"],
  [PRIMARY_CLASSES.MAGE]: ["lol:championClasses.mage", "Mage"],
  [PRIMARY_CLASSES.MARKSMAN]: ["lol:championClasses.marksman", "Marksman"],
  [PRIMARY_CLASSES.SLAYER]: ["lol:championClasses.slayer", "Slayer"],
  [PRIMARY_CLASSES.TANK]: ["lol:championClasses.tank", "Tank"],
  [PRIMARY_CLASSES.SPECIALIST]: [
    "lol:championClasses.specialist",
    "Specialist",
  ],
  [SECONDARY_CLASSES.ENCHANTER]: ["lol:championClasses.enchanter", "Enchanter"],
  [SECONDARY_CLASSES.CATCHER]: ["lol:championClasses.catcher", "Catcher"],
  [SECONDARY_CLASSES.JUGGERNAUT]: [
    "lol:championClasses.juggernaut",
    "Juggernaut",
  ],
  [SECONDARY_CLASSES.DIVER]: ["lol:championClasses.diver", "Diver"],
  [SECONDARY_CLASSES.BURST]: ["lol:championClasses.burst", "Burst"],
  [SECONDARY_CLASSES.BATTLEMAGE]: [
    "lol:championClasses.battlemage",
    "Battlemage",
  ],
  [SECONDARY_CLASSES.ARTILLERY]: ["lol:championClasses.artillery", "Artillery"],
  [SECONDARY_CLASSES.ASSASSIN]: ["lol:championClasses.assassin", "Assassin"],
  [SECONDARY_CLASSES.SKIRMISHER]: [
    "lol:championClasses.skirmisher",
    "Skirmisher",
  ],
  [SECONDARY_CLASSES.VANGUARD]: ["lol:championClasses.vanguard", "Vanguard"],
  [SECONDARY_CLASSES.WARDEN]: ["lol:championClasses.warden", "Warden"],
  [SECONDARY_CLASSES.MARKSMAN]: ["lol:championClasses.marksman", "Marksman"],
};

export const CHAMPIONS = {
  1: {
    key: "Annie",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  2: {
    key: "Olaf",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  3: {
    key: "Galio",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.WARDEN,
  },
  4: {
    key: "TwistedFate",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  5: {
    key: "XinZhao",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  6: {
    key: "Urgot",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  7: {
    key: "Leblanc",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  8: {
    key: "Vladimir",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  9: {
    key: "Fiddlesticks",
    primaryClass: PRIMARY_CLASSES.MAGE, // diff from wiki
    subClass: SECONDARY_CLASSES.BURST, // diff from wiki
  },
  10: {
    key: "Kayle",
    primaryClass: PRIMARY_CLASSES.MARKSMAN, // diff from wiki
    subClass: null,
  },
  11: {
    key: "MasterYi",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  12: {
    key: "Alistar",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  13: {
    key: "Ryze",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  14: {
    key: "Sion",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  15: {
    key: "Sivir",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  16: {
    key: "Soraka",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  17: {
    key: "Teemo",
    primaryClass: PRIMARY_CLASSES.MARKSMAN, // diff from wiki
    subClass: null,
  },
  18: {
    key: "Tristana",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  19: {
    key: "Warwick",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  20: {
    key: "Nunu",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  21: {
    key: "MissFortune",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  22: {
    key: "Ashe",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  23: {
    key: "Tryndamere",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  24: {
    key: "Jax",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  25: {
    key: "Morgana",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.CATCHER,
  },
  26: {
    key: "Zilean",
    primaryClass: PRIMARY_CLASSES.CONTROLLER, // diff from wiki
    subClass: SECONDARY_CLASSES.CATCHER, // diff from wiki
  },
  27: {
    key: "Singed",
    primaryClass: PRIMARY_CLASSES.FIGHTER, // diff from wiki
    subClass: SECONDARY_CLASSES.DIVER, // diff from wiki
  },
  28: {
    key: "Evelynn",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  29: {
    key: "Twitch",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  30: {
    key: "Karthus",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  31: {
    key: "Chogath",
    primaryClass: PRIMARY_CLASSES.TANK, // diff from wiki
    subClass: SECONDARY_CLASSES.VANGUARD, // diff from wiki
  },
  32: {
    key: "Amumu",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  33: {
    key: "Rammus",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  34: {
    key: "Anivia",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  35: {
    key: "Shaco",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  36: {
    key: "DrMundo",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  37: {
    key: "Sona",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  38: {
    key: "Kassadin",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  39: {
    key: "Irelia",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  40: {
    key: "Janna",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  41: {
    key: "Gangplank",
    primaryClass: PRIMARY_CLASSES.MARKSMAN, // diff from wiki
    subClass: null,
  },
  42: {
    key: "Corki",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  43: {
    key: "Karma",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  44: {
    key: "Taric",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.WARDEN,
  },
  45: {
    key: "Veigar",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  48: {
    key: "Trundle",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  50: {
    key: "Swain",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  51: {
    key: "Caitlyn",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  53: {
    key: "Blitzcrank",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.CATCHER,
  },
  54: {
    key: "Malphite",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  55: {
    key: "Katarina",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  56: {
    key: "Nocturne",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  57: {
    key: "Maokai",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  58: {
    key: "Renekton",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  59: {
    key: "JarvanIV",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  60: {
    key: "Elise",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  61: {
    key: "Orianna",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  62: {
    key: "MonkeyKing",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  63: {
    key: "Brand",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  64: {
    key: "LeeSin",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  67: {
    key: "Vayne",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  68: {
    key: "Rumble",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  69: {
    key: "Cassiopeia",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  72: {
    key: "Skarner",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  74: {
    key: "Heimerdinger",
    primaryClass: PRIMARY_CLASSES.MAGE, // diff from wiki
    subClass: SECONDARY_CLASSES.BATTLEMAGE, // diff from wiki
  },
  75: {
    key: "Nasus",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  76: {
    key: "Nidalee",
    primaryClass: PRIMARY_CLASSES.SLAYER, // diff from wiki
    subClass: SECONDARY_CLASSES.ASSASSIN, // diff from wiki
  },
  77: {
    key: "Udyr",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  78: {
    key: "Poppy",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.WARDEN,
  },
  79: {
    key: "Gragas",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  80: {
    key: "Pantheon",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  81: {
    key: "Ezreal",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  82: {
    key: "Mordekaiser",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  83: {
    key: "Yorick",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  84: {
    key: "Akali",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  85: {
    key: "Kennen",
    primaryClass: PRIMARY_CLASSES.MAGE, // diff from wiki
    subClass: SECONDARY_CLASSES.BURST, // diff from wiki
  },
  86: {
    key: "Garen",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  89: {
    key: "Leona",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  90: {
    key: "Malzahar",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  91: {
    key: "Talon",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  92: {
    key: "Riven",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  96: {
    key: "KogMaw",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  98: {
    key: "Shen",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.WARDEN,
  },
  99: {
    key: "Lux",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.ARTILLERY,
  },
  101: {
    key: "Xerath",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.ARTILLERY,
  },
  102: {
    key: "Shyvana",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  103: {
    key: "Ahri",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  104: {
    key: "Graves",
    primaryClass: PRIMARY_CLASSES.MARKSMAN, // diff from wiki
    subClass: null,
  },
  105: {
    key: "Fizz",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  106: {
    key: "Volibear",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  107: {
    key: "Rengar",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  110: {
    key: "Varus",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  111: {
    key: "Nautilus",
    primaryClass: PRIMARY_CLASSES.TANK, // diff from wiki
    subClass: SECONDARY_CLASSES.CATCHER, // diff from wiki
  },
  112: {
    key: "Viktor",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  113: {
    key: "Sejuani",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  114: {
    key: "Fiora",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  115: {
    key: "Ziggs",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.ARTILLERY,
  },
  117: {
    key: "Lulu",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  119: {
    key: "Draven",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  120: {
    key: "Hecarim",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  121: {
    key: "Khazix",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  122: {
    key: "Darius",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  126: {
    key: "Jayce",
    primaryClass: PRIMARY_CLASSES.FIGHTER, // diff from wiki
    subClass: SECONDARY_CLASSES.DIVER, // diff from wiki
  },
  127: {
    key: "Lissandra",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  131: {
    key: "Diana",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  133: {
    key: "Quinn",
    primaryClass: PRIMARY_CLASSES.MARKSMAN, // diff from wiki
    subClass: null,
  },
  134: {
    key: "Syndra",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  136: {
    key: "AurelionSol",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  141: {
    key: "Kayn",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  "141_1": {
    key: "Kayn",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  "141_2": {
    key: "Kayn",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  142: {
    key: "Zoe",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  143: {
    key: "Zyra",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.CATCHER,
  },
  145: {
    key: "Kaisa",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  147: {
    key: "Seraphine",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  150: {
    key: "Gnar",
    primaryClass: PRIMARY_CLASSES.FIGHTER, // diff from wiki
    subClass: SECONDARY_CLASSES.DIVER, // diff from wiki
  },
  154: {
    key: "Zac",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  157: {
    key: "Yasuo",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  161: {
    key: "Velkoz",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.ARTILLERY,
  },
  163: {
    key: "Taliyah",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  164: {
    key: "Camille",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  166: {
    key: "Akshan",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  200: {
    key: "Belveth",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  201: {
    key: "Braum",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.WARDEN,
  },
  202: {
    key: "Jhin",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  203: {
    key: "Kindred",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  221: {
    key: "Zeri",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  222: {
    key: "Jinx",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  223: {
    key: "TahmKench",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.WARDEN,
  },
  233: {
    key: "Briar",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  234: {
    key: "Viego",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  235: {
    key: "Senna",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  236: {
    key: "Lucian",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  238: {
    key: "Zed",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  240: {
    key: "Kled",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  245: {
    key: "Ekko",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  246: {
    key: "Qiyana",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  254: {
    key: "Vi",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  266: {
    key: "Aatrox",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  267: {
    key: "Nami",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  268: {
    key: "Azir",
    primaryClass: PRIMARY_CLASSES.MAGE, // diff from wiki
    subClass: SECONDARY_CLASSES.BATTLEMAGE, // diff from wiki
  },
  350: {
    key: "Yuumi",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  360: {
    key: "Samira",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  412: {
    key: "Thresh",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.CATCHER,
  },
  420: {
    key: "Illaoi",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  421: {
    key: "RekSai",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.DIVER,
  },
  427: {
    key: "Ivern",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.CATCHER,
  },
  429: {
    key: "Kalista",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  432: {
    key: "Bard",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.CATCHER,
  },
  497: {
    key: "Rakan",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.CATCHER,
  },
  498: {
    key: "Xayah",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  516: {
    key: "Ornn",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  517: {
    key: "Sylas",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  518: {
    key: "Neeko",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  523: {
    key: "Aphelios",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  526: {
    key: "Rell",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.VANGUARD,
  },
  555: {
    key: "Pyke",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  711: {
    key: "Vex",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BURST,
  },
  777: {
    key: "Yone",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  875: {
    key: "Sett",
    primaryClass: PRIMARY_CLASSES.FIGHTER,
    subClass: SECONDARY_CLASSES.JUGGERNAUT,
  },
  876: {
    key: "Lillia",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  887: {
    key: "Gwen",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  888: {
    key: "Renata",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  895: {
    key: "Nilah",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  897: {
    key: "KSante",
    primaryClass: PRIMARY_CLASSES.TANK,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  901: {
    key: "Smolder",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
  902: {
    key: "Milio",
    primaryClass: PRIMARY_CLASSES.CONTROLLER,
    subClass: SECONDARY_CLASSES.ENCHANTER,
  },
  910: {
    key: "Hwei",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.ARTILLERY,
  },
  950: {
    key: "Naafiri",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.ASSASSIN,
  },
  893: {
    key: "Aurora",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.BATTLEMAGE,
  },
  799: {
    prerelease: new Date() < new Date("2024-11-06"),
    key: "Ambessa",
    primaryClass: PRIMARY_CLASSES.SLAYER,
    subClass: SECONDARY_CLASSES.SKIRMISHER,
  },
  800: {
    key: "Mel",
    primaryClass: PRIMARY_CLASSES.MAGE,
    subClass: SECONDARY_CLASSES.ARTILLERY,
  },
  804: {
    prerelease: new Date() < new Date("2025-07-15"),
    key: "Yunara",
    primaryClass: PRIMARY_CLASSES.MARKSMAN,
    subClass: null,
  },
};

export const CHAMPIONS_KEY_TO_ID = Object.entries(CHAMPIONS)
  // remove champ transformation IDs (e.g. Kayn)
  .filter(([id]) => !Number.isNaN(Number(id)))
  .map(([id, info]) => ({ ...info, id: Number(id) }))
  .reduce((acc, curr) => {
    acc[curr.key] = curr.id;
    acc[curr.key.toLowerCase()] = curr.id;
    return acc;
  }, {});
